import { render, staticRenderFns } from "./IdentityDictionarySelection.vue?vue&type=template&id=b0a2be64&"
import script from "./IdentityDictionarySelection.vue?vue&type=script&lang=js&"
export * from "./IdentityDictionarySelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports